import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MaterialCountingPieChart } from "../../../components/charts/MaterialCountingPieChart";
import CampaignAnalysisAccordion from "./CampaignAnalysisAccordion";
import { CHART_HEIGHTS } from "./campaignChartConstants";

const CampaignSortingEfficiencySection = ({
  retraitChartData,
  errorsByCategory,
  errorsByCategoryLabel,
  defaultOpen = true,
  storageKey = "sorting-efficiency",
  isLoading = false,
}) => {
  const { t } = useTranslation();

  const sortedCategories = useMemo(() => {
    return Object.keys(errorsByCategory).sort(
      (a, b) => errorsByCategory[b] - errorsByCategory[a],
    );
  }, [errorsByCategory]);

  return (
    <CampaignAnalysisAccordion
      title={t("campaign.sortingEfficiencyTitle")}
      subtitle={t("campaign.sortingEfficiencySubtitle")}
      defaultOpen={defaultOpen}
      storageKey={storageKey}
    >
      {isLoading ? (
        <div className="flex justify-center py-8">
          <div className="campaign-analysis-card__empty">{t("Loading")}</div>
        </div>
      ) : (
        <div className="campaign-sorting-efficiency__grid">
          <div className="campaign-analysis-card">
            <h3 className="campaign-analysis-card__title">
              {t("campaign.globalRemovalRateTitle")}
            </h3>
            <div
              className="campaign-analysis-card__chart"
              style={{ height: CHART_HEIGHTS.LARGE }}
            >
              {retraitChartData.total > 0 ? (
                <MaterialCountingPieChart
                  dataChart={retraitChartData.values}
                  labelChart={retraitChartData.labels}
                  materialTotal={retraitChartData.total}
                  colorChart={retraitChartData.colors}
                  showMaterialTotal={false}
                  radius={["45%", "70%"]}
                  centerLabelVariant="errors"
                />
              ) : (
                <div className="campaign-analysis-card__empty">
                  {t("No data available")}
                </div>
              )}
            </div>
          </div>

          <div className="campaign-analysis-card">
            <h3 className="campaign-analysis-card__title">
              {t("campaign.totalObjectsRemovedTitle")}
            </h3>
            {sortedCategories.length > 0 ? (
              <div className="campaign-sorting-efficiency-table-wrapper">
                <table className="campaign-sorting-efficiency-table">
                  <thead>
                    <tr>
                      <th scope="col">{t("campaign.wasteTypeColumn")}</th>
                      <th scope="col">{t("Total")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedCategories.map((cat) => (
                      <tr key={cat}>
                        <td>{t(errorsByCategoryLabel[cat] || cat)}</td>
                        <td>{errorsByCategory[cat]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="campaign-analysis-card__empty-text">
                {t("No material")}
              </p>
            )}
          </div>
        </div>
      )}
    </CampaignAnalysisAccordion>
  );
};

export default CampaignSortingEfficiencySection;
